export var TimePickerTestIds = {
    /** Test ID to grab the root element */
    ROOT: 'hawkins-time-picker-root',
    /** Test ID to grab the element containing the hour options */
    HOURS_CONTAINER: 'hawkins-time-picker-hours-container',
    /** Test ID to grab the element containing the minute options */
    MINUTES_CONTAINER: 'hawkins-time-picker-minutes-container',
    /** Test ID to grab the element containing the second options */
    SECONDS_CONTAINER: 'hawkins-time-picker-seconds-container',
};
